<!-- 分期确认页面 -->
<template>
    <div class="dealer-detail-container">

        <div class="dealer-title">客户信息</div>
        <div class="dealer-list">
            <div class="dealer-item">
                <div class="dealer-item-title">申请手机号</div>
                <div class="dealer-item-content">{{ productInfo.applyMobileMask }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">联系人姓名</div>
                <div class="dealer-item-content">{{ productInfo.userName }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">动力类型</div>
                <div class="dealer-item-content">{{ productInfo.powerType }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">车型</div>
                <div class="dealer-item-content">{{ productInfo.carModel }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">车牌号</div>
                <div class="dealer-item-content">{{ productInfo.licensePlate }}</div>
            </div>
        </div>

        <div class="dealer-title">产品名称</div>
        <div class="dealer-list">
            <div class="dealer-item">
                <div class="dealer-item-title">产品名称</div>
                <div class="dealer-item-content">{{ productInfo.goodsName }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">电池型号</div>
                <div class="dealer-item-content">{{ productInfo.goodsModel }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">设备号</div>
                <div class="dealer-item-content">{{ productInfo.goodsModelNo }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">产品价格</div>
                <div class="dealer-item-content">{{ productInfo.goodsPrice }}元</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">分期首付款</div>
                <div class="dealer-item-content">{{ productInfo.downPayment }}元</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">经销商名称</div>
                <div class="dealer-item-content">{{ productInfo.agentName }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">电工名称</div>
                <div class="dealer-item-content">{{ productInfo.electricianName }}</div>
            </div>
            <div class="dealer-item">
                <div class="dealer-item-title">电工手机号</div>
                <div class="dealer-item-content">{{ productInfo.electricianPhone }}</div>
            </div>
        </div>

        <div class="dealer-title" v-if="['2', '3', '4'].includes(productInfo.status)">处理结果</div>
        <div class="dealer-list" v-if="['2', '3', '4'].includes(productInfo.status)">
            <div class="dealer-item">
                <div class="dealer-item-title">处理意见</div>
                <div class="dealer-item-content">{{ productInfo.status == '3' ? '已拒绝': productInfo.status == '2' || productInfo.status == '4' ? '已同意' : ''}}</div>
            </div>
        </div>

        <div class="dealer-btn" v-if="['0','1'].includes(productInfo.status)">
            <button class="btn" @click="examineFun('3')" :style="{background: '#FD2434'}">拒绝</button>
            <button class="btn" @click="examineFun('2')">同意</button>
        </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { Toast } from 'vant'
  import { dealerDetailApi, dealerBindApi } from '@/apis/kdb';
  
  export default {
    data() {
      return {
        params: {},
        productInfo: {
            applyMobileMask: '',
            userName: '',
            powerType: '',
            carModel: '',
            licensePlate: '',
            goodsName: '',
            goodsModel: '',
            goodsModelNo: '',
            goodsPrice: '',
            downPayment: '',
            status: '',
        }
      }
    },
    async created() {
        this.params = this.$route.query
        await this.dealerDetailFun(this.params)
    },
    methods: {
        async dealerDetailFun(){
            const loadingToast = Toast.loading({
                message: '查询中...',
                forbidClick: true,
                duration: 0,
            })
            try {
                let res = await dealerDetailApi(this.params)
                if (res && res.code == 200) {
                    this.productInfo = res.data
                    // status 0创建，1待确认，2已同意，3已拒绝，4发起借款
                    loadingToast.clear()
                } else {
                    this.$common.toast(res.msg)
                }
            } catch (error) {}
        },
        async examineFun(reason){
            try {
                const { code } =  await dealerBindApi({
                    id: this.productInfo.id,
                    status: reason
                })
                if(code == 200) {
                    this.$common.toast('操作成功')
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 1500)
                }
            } catch (error) {
                console.log(error);
                this.$common.toast(error || '操作失败')
            }
        }
    },
  }
  </script>
  
  <style lang="less" scoped>
  .dealer-detail-container {
    box-sizing: border-box;
    background: #f5f6fa;
    padding: 0.3rem;
    position: relative;
    .dealer-title {
        font-weight: 500;
        font-size: 0.36rem;
        color: #000000;
        line-height: 0.5rem;
        text-align: left;
        margin-bottom: 0.2rem;
        margin-top: 0.4rem;
        &:first-child {
            margin-top: 0.2rem;
        }
    }
    .dealer-list {
        padding: 0.3rem 0.4rem 0 0.4rem;
        background: #ffffff;
        box-shadow: 0rem 0rem 0.3rem 0rem rgba(0, 0, 0, 0.08);
        border-radius: 0.18rem;
        .dealer-item {
            height: 0.6rem;
            margin: 0.25rem 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            border-bottom: 1px solid #e7e7e7;
            &:first-child {
                margin-top: 0;
            }
            &:last-child {
                border: none;
            }

            .dealer-item-title {
                font-weight: 500;
                font-size: 0.3rem;
                color: #333333;
                width: 2rem;
            }
            .dealer-item-content {
                font-weight: 500;
                font-size: 0.3rem;
                color: #333333;
                width: 4rem;
                text-align: right;
            }
        }
    }
    .dealer-btn {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 1.2rem;
        .btn {
            width: 2.96rem;
            height: 0.88rem;
            line-height: 0.88rem;
            text-align: center;
            background: #4d7bfe;
            border-radius: 0.44rem;
            color: #ffffff;
            border: none;
            font-size: 0.36rem;
            font-weight: 500;
        }
    }
  }
  </style>
  